// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2sTYw","productName":"Table_productName__3vXbn"};